function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
export var Component = function Component(_ref) {
  var children = _ref.children,
      computer = _ref.computer,
      mobile = _ref.mobile,
      parent = _ref.parent,
      parentProps = _ref.parentProps,
      tablet = _ref.tablet,
      widescreen = _ref.widescreen;
  return React.createElement(parent, _objectSpread(_objectSpread({}, parentProps), {}, {
    className: classnames(parentProps.className, {
      'show-on-mobile': mobile,
      'show-on-tablet': tablet,
      'show-on-computer': computer,
      'show-on-widescreen': widescreen
    })
  }), children);
};
Component.defaultProps = {
  children: null,
  computer: false,
  mobile: false,
  parent: 'div',
  parentProps: {},
  tablet: false,
  widescreen: false
};
Component.displayName = 'ShowOn';
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  computer: PropTypes.bool,
  mobile: PropTypes.bool,
  parent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  parentProps: PropTypes.object,
  tablet: PropTypes.bool,
  widescreen: PropTypes.bool
} : {};